import React, { useEffect, useState } from "react";
import {
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { SkillsInterface } from "../../interface/skillsInterface";
import axiosInstance from "../../services/axios-instance";
import { DESTROY_SKILL_URL, EDIT_SKILL_URL } from "../../services/endpoints";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    fontWeight: "bold",
    color: theme.palette.text.primary,
}));
const StyledTableRow = styled(TableRow)(() => ({
    backgroundColor: "white",
}));

interface CellNamesParams {
    cellOne: string;
    cellTwo: string;
    cellTree: string;
    cellFour: string;
}

interface MyTableParams {
    data: SkillsInterface[];
    cellNames: CellNamesParams;
    setAllSkills: (
        data:
            | SkillsInterface[]
            | ((prevSkills: SkillsInterface[]) => SkillsInterface[])
    ) => void;
}
const SkillsTable = ({ data, cellNames, setAllSkills }: MyTableParams) => {
    const [editedSkillNames, setEditedSkillNames] = useState<
        { id: number; name: string }[]
    >([]);

    useEffect(() => {
        if (data) {
            setEditedSkillNames(
                data.map((row) => ({ id: row?.id, name: row?.name }))
            );
        }
    }, [data]);
    const handleNameChange = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        id: number
    ) => {
        setEditedSkillNames((prev) => {
            const newSkills = [...prev];
            const index = newSkills.findIndex((skill) => skill.id === id);
            newSkills[index] = {
                ...newSkills[index],
                name: event.target.value,
            };
            return newSkills;
        });
    };

    const handleSkillEdit = () => {
        return axiosInstance
            .put(EDIT_SKILL_URL, editedSkillNames)
            .then((editedRes) => setAllSkills(editedRes.data.skills));
    };

    const handleSkillDelete = (id: number) => {
        axiosInstance
            .delete(DESTROY_SKILL_URL(id))
            .then(() => {
                setAllSkills((prevSkills: SkillsInterface[]) =>
                    prevSkills.filter((skill) => skill.id !== id)
                );
            })
            .catch((error) => {
                console.error(error);
            });
    };

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow
                        sx={{
                            backgroundColor: "#f9fafc",
                        }}
                    >
                        <StyledTableCell>{cellNames.cellOne}</StyledTableCell>
                        <StyledTableCell>{cellNames.cellTwo}</StyledTableCell>
                        <StyledTableCell>{cellNames.cellTree}</StyledTableCell>
                        <StyledTableCell>{cellNames.cellFour}</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row: SkillsInterface, index: number) => (
                        <StyledTableRow key={row.id}>
                            <TableCell>{row.name}</TableCell>
                            <TableCell>
                                <TextField
                                    placeholder="Edit skill"
                                    value={editedSkillNames[index]?.name || ""}
                                    onChange={(event) =>
                                        handleNameChange(event, row.id)
                                    }
                                />
                            </TableCell>
                            <TableCell>
                                <Button
                                    variant="contained"
                                    color="success"
                                    onClick={handleSkillEdit}
                                >
                                    Edit skill
                                </Button>
                            </TableCell>
                            <TableCell>
                                <Button
                                    variant="contained"
                                    color="error"
                                    onClick={() => handleSkillDelete(row.id)}
                                >
                                    Remove skill
                                </Button>
                            </TableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default SkillsTable;
